import CompanyService from "@/service/company-service";
import PersonService from "@/service/person-service";
import WhatsAppOptInService from "@/service/whatsapp-opt-in-services";
import uuid from "uuid";
import { zLanguageChanger } from "zoox-components";
import StrategyManager from "@/strategies/manager";
import Reservation from "@/components/shared/GuestForm/Model/Reservation";
import { validationMixin } from "smck-service";
import { zFlagNumber } from "zoox-components";
export default {
  name: "WhatsAppOptIn",
  mixins: [validationMixin],

  components: {
    "z-language-changer": zLanguageChanger,
    "z-flag-number": zFlagNumber
  },
  data() {
    return {
      companyService: new CompanyService(),
      personService: new PersonService(),
      WhatsAppOptInService: new WhatsAppOptInService(),
      strategyManager: new StrategyManager(),
      reservationToShow: new Reservation(),
      phoneNumber: "",
      currentPhoneNumber: "",
      optinChecked: false,
      reservation: {},
      guest: {},
      personId: "",
      fnrhId: "",
      domain: "",
      numberDisabled: true,
      disabled: true,
      loading: false,
      guestControl: false
    };
  },
  created() {
    if (
      this.guest.mobileCityCode == null ||
      this.guest.mobilePhoneNumber == null
    ) {
      this.guest.mobileCityCode = "";

      this.guest.mobilePhoneNumber = "";
    }
    if (this.$customization && this.$customization.enableRedirect) {
      const strategy = this.$customization.redirectTo || 0;
      if (strategy === 0) {
        this.guestControl = true;
      }
    }
  },
  async mounted() {
    this.domain = window.location.host;
    this.reservation = this.$store.state.currentReservation;

    this.reservationId = this.$route.params.reservationId;
    this.guestId = this.$route.params.guestId;
    const company = this.companyService.getLocalCompany(true);

    if (company) {
      this.companyName = company.name;
    }

    this.$_gtagPlugin_trackEvent("ENTERED_GUEST_LIST", "PORTAL", this.guestId);

    if (this.reservation && this.reservation.guests.length > 0) {
      this.guest = this.reservation.guests.find(g => g.masterGuest);
      this.personId = this.guest.personId;
      this.fnrhId = this.guest.fnrhId;
      this.setPhoneNumber();

      this.disabled = false;
    }
  },

  watch: {
    reservation: {
      deep: true,
      immediate: true,
      handler: function(value) {
        this.reservationToShow = value;
      }
    }
  },
  methods: {
    async redirectToManageStrategy() {
      if (!this.optinChecked) {
        this.nextStep();
        return;
      }
      if (this.$refs.form.validate()) {
        this.nextStep();
      }
    },
    getCustomLogo: function() {
      return this.customLogo
        ? this.customLogo + `?unique=${uuid.v4()}`
        : require("@/assets/images/placeholder.png");
    },
    async nextStep() {
      this.loading = true;
      this.disabled = true;
      if (this.personId) {
        this.WhatsAppOptInService.savePersonWppOptin(
          this.reservation.companyId,
          this.personId,
          this.optinChecked
        );

        this.WhatsAppOptInService.finalizeReservation(
          this.reservation.id,
          this.guest.id
        );
      }
      this.currentPhoneNumber =
        this.guest.mobileCityCode + this.guest.mobilePhoneNumber;

      if (
        this.currentPhoneNumber !== this.phoneNumber &&
        !(this.phoneNumber == null || this.phoneNumber.match(/^ *$/) !== null)
      ) {
        const lastIndexMobileCityCode = this.getLastIndexDdd(
          this.guest.mobilePhoneMask
        );
        const mobileCityCode = this.currentPhoneNumber.substr(
          0,
          lastIndexMobileCityCode
        );
        const mobilePhoneNumber = this.currentPhoneNumber.substr(
          lastIndexMobileCityCode,
          this.currentPhoneNumber.length
        );

        this.WhatsAppOptInService.updatePersonFnrh(
          this.fnrhId,
          mobileCityCode,
          mobilePhoneNumber
        );
      }

      if (this.$customization && this.$customization.enableRedirect) {
        const strategy = this.$customization.redirectTo || 0;
        if (strategy === 0) {
          await this.strategyManager.setStrategy(0);
          await this.strategyManager.redirect(this.reservation, this.guest);
        } else {
          const guest = this.reservationToShow.guests.find(g => g.masterGuest);
          const strategyManager = new StrategyManager();
          await strategyManager.setStrategy(strategy);
          await strategyManager.redirect(this.reservationToShow, guest);
        }
      } else {
        const guest = this.reservationToShow.guests[0];
        await this.$router.push({ path: `/resume/${guest.fnrhId}` });
      }
    },
    enable: function() {
      if (this.numberDisabled === true) {
        this.numberDisabled = false;
      }
    },
    setPhoneNumber: function() {
      const lastIndexMobileCityCode = this.getLastIndexDdd(
        this.guest.mobilePhoneMask
      );
      if (
        this.guest.mobileCityCode &&
        this.guest.mobilePhoneNumber &&
        !(
          this.guest.mobilePhoneNumber.substring(0, lastIndexMobileCityCode) ===
          this.guest.mobileCityCode
        )
      ) {
        this.phoneNumber =
          this.guest.mobileCityCode + this.guest.mobilePhoneNumber;
      } else {
        this.phoneNumber = this.guest.mobilePhoneNumber;
      }
    },
    getLastIndexDdd(mask) {
      /* eslint-disable no-useless-escape */
      mask = mask || "";
      const maskDdd = mask
        ? mask
            .replace(/[\(|\)]/g, "")
            .replace(/[-|\.|\/]/g, " ")
            .split(" ")[0]
        : "";
      if (mask.length === maskDdd.length) {
        return 0;
      }
      return maskDdd.length >= 4 ? maskDdd.length - 2 : maskDdd.length;
    },
    numberInputMobile(val) {
      this.phoneIsFilled(val);

      const lastIndexMobileCityCode = this.getLastIndexDdd(
        this.guest.mobilePhoneMask
      );
      this.guest.mobilePhoneNumber = val;
      this.guest.mobilePhoneNumber = val
        ? val.substring(lastIndexMobileCityCode)
        : "";
      this.guest.mobileCityCode = val
        ? val.substring(0, lastIndexMobileCityCode)
        : "";
      this.guest.mobileCityCode = val
        ? val.substring(0, lastIndexMobileCityCode)
        : "";
    },
    ddiInputMobile(val) {
      this.guest.mobileCountryCode = val.phoneDial;
      this.guest.mobileCountryCode = val.phoneDial;
      this.guest.mobilePhoneMask = val.mobilePhoneMask;
      this.guest.mobilePhoneCountryCode = val.code;
    },
    onMobileMaskSelect(mask) {
      this.guest.mobilePhoneMask = mask;
      for (let x in this.currentReservation.guests) {
        if (this.currentReservation.guests[x].id === this.guest.id) {
          this.currentReservation.guests[x].mobilePhoneMask = mask;
          break;
        }
      }
    }
  }
};
